import {Action} from 'redux';
import {ActionsObservable, combineEpics, StateObservable} from 'redux-observable';
import {concat, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import * as catalogSearch from './mx/CatalogSearchEpics';
import * as calculatorMX from './mx/creditoReal/CalculatorEpics';
import * as loanApplicationsEpicsCR from './mx/creditoReal/LoanApplicationsEpics';
import * as crValidationIdEpics from './mx/creditoReal/CRValidationIdEpics';
import * as loanApplicationsEpicsTC from './mx/turboCash/LoanApplicationsEpics';
import * as loginEpic from './LoginEpic';
import * as profileEpic from './ProfileEpic';
import * as intentsEpic from './IntentsEpic';
import * as errorEpic from './ErrorEpic';
import * as stepEpic from './StepEpic';
import * as rfcEpics from './mx/creditoReal/RFCEpics';
import * as utmEpics from './UTMEpic';
import * as fileUploadEpics from './mx/FileUploadEpics';
import * as AlertActions from '../../common/actions/AlertActions';
import * as GlobalActions from '../../common/actions/GlobalActions';
import {ERROR} from '../constants/LabelConstants';

const rootEpic = (
    action$: ActionsObservable<Action>,
    store$: StateObservable<void>,
    dependencies: any,
) => combineEpics(
    errorEpic.alertMessage,
    errorEpic.retryApiModal,
    stepEpic.onSelectStepEpic,
    loginEpic.goToLoginEpic,
    loginEpic.sessionExpiredEpic,
    loginEpic.logoutEpic,
    loginEpic.logoutWithoutTokensEpic,
    loginEpic.ssoGetTokenByCodeAndRedirect,
    profileEpic.getInfoProfileFederatedEpic,
    intentsEpic.getIpEpic,
    intentsEpic.getGeoLocationEpic,
    catalogSearch.getAllCatalogSearchMX,
    catalogSearch.searchBrandsMX,
    catalogSearch.searchModelsMX,
    catalogSearch.searchVersionsMX,
    catalogSearch.getAllQuotationInsurances,
    catalogSearch.onChangeIncludeInsurance,
    catalogSearch.onChangeIncludeInsuranceToFalse,
    catalogSearch.getAllCatalogGraphCmsMX,
    calculatorMX.shouldCalculateQuotasMX,
    calculatorMX.calculateQuotasMX,
    calculatorMX.validatePostalCodeAndSetState,
    loanApplicationsEpicsCR.goToHomeEpic,
    loanApplicationsEpicsCR.goToTurboCashEpic,
    loanApplicationsEpicsCR.goToSimulatorProfileEpic,
    loanApplicationsEpicsCR.goToApplicantDataMXAction,
    loanApplicationsEpicsCR.goToCalculatorMXAction,
    loanApplicationsEpicsCR.saveApplicantDataMXAction,
    loanApplicationsEpicsCR.sendHubspotDataAction,
    loanApplicationsEpicsCR.getLocationByPostalCodeHome,
    loanApplicationsEpicsCR.getLocationByPostalCodeEmployment,
    loanApplicationsEpicsCR.resendNip,
    loanApplicationsEpicsCR.goToDomicileMXAction,
    loanApplicationsEpicsCR.saveApplicantDomicileMXAction,
    loanApplicationsEpicsCR.saveEmploymentPartialDataMXAction,
    loanApplicationsEpicsCR.goToBureauValidationMXAction,
    loanApplicationsEpicsCR.validateBureauNip,
    loanApplicationsEpicsCR.validateIdentityNip,
    loanApplicationsEpicsCR.validateProfile,
    loanApplicationsEpicsCR.goToBureauQueryErrorMXAction,
    loanApplicationsEpicsCR.goToCreditHistoryMXAction,
    loanApplicationsEpicsCR.checkIfAppliesToTurboCash,
    loanApplicationsEpicsCR.goToTurboCashSimulatorMXAction,
    loanApplicationsEpicsCR.goToNotAcceptQuoteTurboCashMXAction,
    loanApplicationsEpicsCR.goToAcceptQuoteTurboCashMXAction,
    loanApplicationsEpicsCR.saveEmploymentDataMXAction,
    loanApplicationsEpicsCR.goToReferencesMXAction,
    loanApplicationsEpicsCR.saveInsuranceMXAction,
    loanApplicationsEpicsCR.saveOtherReferencesMXAction,
    loanApplicationsEpicsCR.goToInsurancesMXAction,
    loanApplicationsEpicsCR.saveCreditHistoryMXAction,
    loanApplicationsEpicsCR.goToEmploymentMXAction,
    loanApplicationsEpicsCR.getLoanApplicationForSummaryMX,
    loanApplicationsEpicsCR.getLoanApplicationDocuments,
    loanApplicationsEpicsCR.goToFilesUploadMXAction,
    loanApplicationsEpicsCR.goToStep,
    loanApplicationsEpicsCR.goToFinishedMXAction,
    loanApplicationsEpicsCR.saveMarketingMXAction,
    loanApplicationsEpicsCR.saveFileUploadMXAction,
    loanApplicationsEpicsCR.goToLoanApplicationSummaryMXAction,
    loanApplicationsEpicsCR.goToSummaryMXAction,
    loanApplicationsEpicsCR.saveCalculatorDataMXAction,
    loanApplicationsEpicsCR.saveTurboCashCalculatorData,
    loanApplicationsEpicsCR.saveProfileSimulatorData,
    // loanApplicationsEpicsCR.setHomeStateAction,
    // loanApplicationsEpicsCR.setHomeStateColonyAction,
    loanApplicationsEpicsCR.setEmploymentStateAction,
    loanApplicationsEpicsCR.setEmploymentStateColonyAction,
    loanApplicationsEpicsCR.fillCalculatorDataMX,
    loanApplicationsEpicsCR.verifyCalculatorDataMXAction,
    rfcEpics.calculateRfcMX,
    utmEpics.getUTMParamsFromUrl,
    utmEpics.getParamsFromUrl,
    loanApplicationsEpicsTC.saveTurboCashData,
    loanApplicationsEpicsTC.getLocationByPostalCodeEmployment,
    loanApplicationsEpicsTC.getLocationByPostalCodeReferencesEmployment,
    loanApplicationsEpicsTC.goToTurboCashThanksEpic,
    loanApplicationsEpicsTC.getLoanApplicationForSummaryMX,
    fileUploadEpics.processFilesToUploadAction,
    fileUploadEpics.deleteFileAction,
    fileUploadEpics.uploadFilesAction,
    crValidationIdEpics.onCrShouldSendToIdValidationEpic,
    crValidationIdEpics.onCrVerifyValidationIdResponseEpic,
    crValidationIdEpics.onCrReSendCurpToIdValidationEpic,
)(action$, store$, dependencies).pipe(
    catchError((error, source) => {
        console.log("[ERROR] (global catch):", error);
        return concat(
            of(AlertActions.ADD_ALERT_ACTION.action(ERROR.UNKNOWN_ERROR)),
            of(GlobalActions.CLEAR_LOADER_ACTION.action()),
            source
        );
    })
);

export default rootEpic;
